import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campVcReorder: FaireAdCampaignEntity = {
  token: "camp_vc_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_verve_culture",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 1800,
  startedRunningAt: "2025-03-26",
  segmentMetrics: {
    numReorderConversions: 308,
    salesDollars: 131466,
    totalAdsSpendDollars: 10004,
    returnOnAdSpend: 13.14,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-24T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
